import { useDispatch, useSelector } from 'react-redux'

export default function useFilter (key = '') {
    const dispatch = useDispatch()
    const sellerInfo = useSelector(state => state.newSellerInfo[key])
    const allSellerInfos = useSelector(state => state.newSellerInfo)

    const setSellerInfo = value => {
        dispatch({
            type: '@newSellerInfo/SET',
            key,
            value
        })
    }

    const resetAllSellerInfos = () => {
        dispatch({
            type: '@newSellerInfo/RESET'
        })
    }

    return {
        sellerInfo,
        resetAllSellerInfos,
        setSellerInfo,
        allSellerInfos,
    }
}
